import React, { Component } from 'react';
import { SESSION_KEYS, syncTokenStorages, isUsingKeycloakAuth, isProfileIncompleteError, verifyKeycloakToken } from './keycloakUtils';
import navigateTo from '../../app/navigateTo';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { setNewToken } from '../../redux/actions/accountActions';
import { appLogout } from '../../libs/utils';
import Loading from '../../custom/Loading';

class RequireAuth extends Component {
  state = {
    isChecking: true,
    hasAccess: false
  };

  componentDidMount() {
    this.checkAuthentication();
  }

  checkAuthentication = async () => {
    const tokenSession = sessionStorage.getItem(SESSION_KEYS.ACCESS_TOKEN);
    const tokenRedux = this.props.access_token;

    if (tokenRedux) {
      syncTokenStorages(tokenRedux);
    }

    const currentToken = tokenSession || tokenRedux;

    if (!currentToken) {
      this.setState({ isChecking: false, hasAccess: false });
      return navigateTo({ to: '/login' });
    }

    const isKeycloakToken = isUsingKeycloakAuth();

    if (isKeycloakToken) {
      try {
        await verifyKeycloakToken(currentToken);

        this.setState({ isChecking: false, hasAccess: true });
        return;
      } catch (error) {
        if (isProfileIncompleteError(error)) {
          return navigateTo({ to: '/profile-incomplete-error' });
        }        

        appLogout();
        return navigateTo({ to: '/' });
      }
    } else {
      this.setState({ isChecking: false, hasAccess: true });
      return;
    }
  };

  render() {
    const { isChecking, hasAccess } = this.state;

    if (isChecking) {
      return <Loading center />;
    }

    if (hasAccess) {
      return this.props.children;
    }

    return <Loading center />;
  }
}

export default connect(
  state => ({
    access_token: get(state, 'account.access_token')
  }),
  { setNewToken }
)(RequireAuth);



// WEBPACK FOOTER //
// ./src/components/auth/RequireAuth.js